<template>
    <div class="content-scroll">
        <div class="content-box page">
            <el-tabs active-name="first" class="pageTitle">
                <el-tab-pane label="订单记录" name="first"></el-tab-pane>
            </el-tabs>
            <el-button type="success" class="posTopBtn" size="small" @click="handleForm(false)" icon="el-icon-plus"
                       title="新增">新增
            </el-button>

            <el-form ref="form" :inline="true" :model="filters" size="small">
                <el-form-item label="搜索条件" prop="country">
                    <el-input clearable v-model="filters.country" @change="searchPage"></el-input>
                </el-form-item>
                <el-form-item label="产品类型" prop="productTypeId">
                    <el-select clearable size="small" filterable v-model="filters.productTypeId" placeholder="请选择产品类型"
                               @change="searchPage">
                        <el-option v-for="item in productTypeOption" :label="item.name" :value="item.id"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="订单日期">
                    <el-date-picker size="small" v-model="timeRange"
                                    @change="getTimeRange($event,'createTimeStart','createTimeEnd')" type="daterange"
                                    value-format="yyyy-MM-dd" :picker-options="recentOptions" range-separator="-"
                                    start-placeholder="申请开始日期" end-placeholder="申请结束日期" align="right"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" icon="el-icon-search" @click="searchPage()">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" class="el-icon-download" type="warning" @click="handleExport()">导出
                    </el-button>
                </el-form-item>
            </el-form>

            <!--列表-->
            <el-table @sort-change="sortChange" :data="pageData" border v-loading="tLoading">
                <el-table-column prop="id" label="序号" width="60" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="contact" label="联系人"
                                 align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="company" label="公司"
                                 align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="country" label="国家"
                                 align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="产品类型"
                                 align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="price" label="人民币金额" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="currencyAmount" label="金额" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="currency" label="币种" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="exchangeRate" label="汇率" align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="exportCountry" label="出口国家"
                                 align="center"></el-table-column>
                <el-table-column :show-overflow-tooltip="true" prop="orderTime" label="订单日期"
                                 align="center"></el-table-column>
                <el-table-column label="操作" width="150" align="right">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" title="修改" @click="handleForm(true, scope.row)"
                                   icon="el-icon-edit"></el-button>
                        <el-button type="danger" size="mini" title="删除" @click="handleDel(scope.row)"
                                   icon="el-icon-delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!--工具条-->
            <div class="toolbar" style="text-align: right;">
                <el-pagination @current-change="handleCurrentChange" background :current-page="filters.pageIndex"
                               :page-size="filters.pageSize" layout="total, prev, pager, next"
                               :total="totalNum"></el-pagination>
            </div>

            <!--新增界面-->
            <el-dialog :title="saveType ? '记录编辑':'记录新增'" :visible.sync="aVisible" width="50%"
                       :modal-append-to-body="true" :close-on-click-modal="false" top="10vh">
                <el-form :model="formData" :rules="formRules" label-width="120px" ref="formFileds" size="small">
                    <el-form-item label="订单客户 " prop="customerId" class="w450">
                        <el-button size="small" :type="formData.customerId ? '' : 'primary'" @click="cVisible = true">{{
                            formData.customerId ? '已选择Id(' + formData.customerId + ')' : '选择客户'}}
                        </el-button>
                    </el-form-item>
                    <el-form-item label="币种 " prop="currency" class="inlineForm w450">
                        <el-select v-model="formData.currency" placeholder="请选择币种"  @blur="setPrice()">
                            <el-option
                                    v-for="item in currencyList"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汇率 " prop="exchangeRate" class="inlineForm w450">
                        <el-input clearable v-model="formData.exchangeRate" type="number" @blur="setPrice()"></el-input>
                    </el-form-item>
                    <el-form-item label="金额 " prop="currencyAmount" class="inlineForm w450">
                        <el-input clearable v-model="formData.currencyAmount" @blur="setPrice()"></el-input>
                    </el-form-item>
                    <el-form-item label="人民币金额 " prop="price" class="inlineForm w450">
                        <el-input clearable v-model="formData.price" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="产品类型 " prop="productTypeId" class="inlineForm w450">
                        <el-select clearable size="small" filterable
                                   v-model="formData.productTypeId" placeholder="请选择产品类别">
                            <el-option v-for="item in productTypeOption" :label="item.name"
                                       :value="item.id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="订单日期" prop="orderTime" class="inlineForm w450">
                        <el-date-picker size="small" v-model="formData.orderTime" type="date"
                                        value-format="yyyy-MM-dd"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="出口国家 " prop="exportCountry" class="inlineForm w450">
                        <el-input clearable v-model="formData.exportCountry"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click.native="aVisible = false">取消</el-button>
                        <el-button type="primary"
                                   @click="saveType ? formSubmit(updateUrl, formData) : formSubmit(addUrl, formData)"
                                   :loading="bLoading">提交
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>

            <el-dialog :visible.sync="cVisible" width="1300px" :modal-append-to-body="true"
                       :close-on-click-modal="false" top="5%">
                <div class="solt-header">
                    <h2>客户选择</h2>
                </div>
                <customer-list v-if="cVisible" @material="setMaterial"></customer-list>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import CustomerList from '@/components/CustomerList.vue'

    export default {
        components: {
            CustomerList,
        },
        data() {
            let valiNumber = (rule, value, callback) => {//包含小数的数字
                let reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/g;
                if (value === '') {
                    callback(new Error('请输入内容'));
                } else if (!reg.test(value)) {
                    callback(new Error('请输入数字，单位为元，最小到分'));
                } else {
                    callback();
                }
            };
            return {
                pageUrl: '/customer/order/record/list/page',
                updateUrl: '/customer/order/record/saveOrUpdate',
                addUrl: '/customer/order/record/saveOrUpdate',
                deleteUrl: '/customer/order/record/remove',
                exportUrl: '/customer/order/record/export',
                importUrl: '/customer/order/record/import',
                currencyList: ["RMB", "USD", "EUR"],

                filters: {
                    pageSize: 10,
                    pageIndex: 1,
                    customerId: null,
                    createTimeEnd: '',
                    createTimeStart: '',
                    country: '',
                    productTypeId: ''
                },

                formData: {
                    productTypeId: '',
                    customerId: '',
                    price: 0,
                    id: '',
                    orderTime: '',
                    exportCountry: '',
                    currency: 'RMB',
                    exchangeRate: 1.0,
                    currencyAmount: ''
                },
                formRules: {
                    customerId: [
                        {required: true, message: '请选择订单客户', trigger: 'blur'}
                    ],
                    currencyAmount: [
                        {required: true, validator: valiNumber, trigger: "blur"},
                    ],
                    exchangeRate: [
                        {required: true,message: '请输入汇率', trigger: "blur"},
                    ],
                    price: [
                        {trigger: "blur"},
                    ],
                    productTypeId: [
                        {required: true, message: '请选择产品类型', trigger: 'blur'}
                    ],
                },
            }
        },
        computed: {
            ...mapGetters(['username', 'productTypeOption'])
        },
        methods: {
            setMaterial(row) {
                this.cVisible = false;
                this.formData.customerId = row.id;
                row.id = this.formData.id;
                this.mergeObject(this.formData, row)
            },
            setPrice() {
                let a = this.formData.currencyAmount === null ? 0 : this.formData.currencyAmount
                let astr = a.toString()
                astr = astr.replace(',', '')
                let b = this.formData.exchangeRate === null ? 0 : this.formData.exchangeRate;
                let value = (astr * b).toFixed(4)
                this.formData.price =  isNaN(value) ? 0 : value
            }
        },
        mounted() {
            this.filters.customerId = this.$route.query.customerId ? parseInt(this.$route.query.customerId) : null
            this.formData.customerId = this.$route.query.customerId ? parseInt(this.$route.query.customerId) : null
            this.getPage()
        }
    }
</script>